import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';

import {FontAwesomeIconComponent} from './fa-icon/fa-icon.component';
import {IconDetailComponent} from './icon-detail/icon-detail.component';

@NgModule({
	imports: [CommonModule, MatTooltipModule],
	declarations: [IconDetailComponent, FontAwesomeIconComponent],
	exports: [IconDetailComponent, FontAwesomeIconComponent]
})
export class IconModule {}
